import { WordStatus } from '../../types';

export const getWordStyles = (status: WordStatus): string => {
  switch (status) {
    case 'correct':
      return 'bg-green-100 text-green-800 border-green-300 hover:bg-green-200';
    case 'unclear':
      return 'bg-yellow-100 text-yellow-800 border-yellow-300 hover:bg-yellow-200';
    case 'substitution':
      return 'bg-red-100 text-red-800 border-red-300 hover:bg-red-200';
    case 'omission':
      return 'bg-red-100 text-red-800 border-red-300 hover:bg-red-200 opacity-60';
    case 'insertion':
      return 'bg-purple-100 text-purple-800 border-purple-300 hover:bg-purple-200';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-300';
  }
};

export const getDifficultyBadge = (difficulty: 'easy' | 'medium' | 'hard'): string => {
  const colors: Record<string, string> = {
    easy: 'bg-green-100 text-green-700',
    medium: 'bg-yellow-100 text-yellow-700',
    hard: 'bg-red-100 text-red-700'
  };
  return colors[difficulty] || colors.medium;
};

export const getSpeedBadge = (speed: 'slow' | 'normal' | 'fast'): string => {
  const colors: Record<string, string> = {
    slow: 'text-blue-600',
    normal: 'text-green-600',
    fast: 'text-orange-600'
  };
  return colors[speed] || colors.normal;
};

export const getPhonemeScoreColor = (score: number): string => {
  if (score >= 80) return 'text-green-600 bg-green-50 border-green-200';
  if (score >= 60) return 'text-yellow-600 bg-yellow-50 border-yellow-200';
  return 'text-red-600 bg-red-50 border-red-200';
};
